import React from 'react';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    initials: 'MF',
    quote: 'Incorporamos el tratado al estudio y dejó de ser necesario empezar cada demanda desde cero. Hoy resolvemos los casos con mucha más rapidez y seguridad.',
    name: 'Dra. María Ferreyra',
    role: 'Abogada Laboralista · Córdoba'
  }, {
    initials: 'JP',
    quote: 'Los modelos editables y la jurisprudencia organizada nos ahorran horas de trabajo todas las semanas. Se nota que fue elaborado por colegas que ejercen la profesión.',
    name: 'Dr. Juan Pérez',
    role: 'Estudio Jurídico · Buenos Aires'
  }, {
    initials: 'LG',
    quote: 'La inversión se recuperó con el primer expediente. Tener contratos, telegramas y escritos listos para adaptar hace una diferencia enorme.',
    name: 'Dra. Laura González',
    role: 'Abogada Litigante · Rosario'
  }];
  return <section className="mx-auto max-w-6xl px-5 py-14 md:px-8 md:py-20" data-id="element-191" data-mp="h67yo29qzk9b">
      <div className="mx-auto mb-9 max-w-2xl text-center" data-id="element-192" data-mp="h818trjkkmm2">
        <p className="text-sm font-bold uppercase tracking-[0.18em] text-accent" data-id="element-193" data-mp="m62nm09ypzrq">
          Experiencia profesional
        </p>
        <h2 className="mt-2 font-display text-3xl font-bold text-white md:text-4xl" data-id="element-194" data-mp="79ldfcdier6r">
          Lo que dicen los abogados que ya lo utilizan
        </h2>
      </div>

      <div className="grid gap-5 md:grid-cols-3" data-id="element-195" data-mp="zxh8ydrced1y">
        {testimonials.map(testimonial => <article key={testimonial.name} className="border border-white/10 bg-charcoal p-6" data-id="element-196" data-mp="14vsmayguj5ox">
            <div className="flex items-center justify-between" data-id="element-197" data-mp="q6cudf5kwu7n">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent font-bold text-ink" data-id="element-198" data-mp="v4xuzfoqtfwm">
                {testimonial.initials}
              </span>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-199" data-mp="1nlqrn6t9ekov">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} size={13} className="fill-accent text-accent" aria-hidden="true" data-id="element-200" data-mp="1xfmvrbdxn1vu" data-mpi={index} />)}
              </div>
            </div>
            <blockquote className="mt-5 text-sm leading-relaxed text-stone-300" data-id="element-201" data-mp="1jhg3qbvnzw43">
              “{testimonial.quote}”
            </blockquote>
            <footer className="mt-6 border-t border-white/10 pt-4" data-id="element-202" data-mp="1ekzj3rnobzvr">
              <p className="text-sm font-bold text-white" data-id="element-203" data-mp="19qvaz52o9lt3">{testimonial.name}</p>
              <p className="mt-1 text-xs text-stone-500" data-id="element-204" data-mp="14ud707f61rht">{testimonial.role}</p>
            </footer>
          </article>)}
      </div>
    </section>;
}